import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';

// Navbar call to action: "Habla con un especialista" → specialist form.
// The advertising landings (free-demo-cx) keep their own "Free Demo" button.
const SpecialistCta = ({ language, advertisingView, sendDemoEvent }) => {
  const [t] = useTranslation('global');

  if (advertisingView) {
    return <Button language={language} onClick={sendDemoEvent}>Free Demo</Button>;
  }

  return (
    <Link to={`/${language}/specialist`}>
      <button type="button">{t('homeV2.hero.ctaPrimary')}</button>
    </Link>
  );
};

SpecialistCta.defaultProps = {
  advertisingView: false,
  sendDemoEvent: () => {},
};

SpecialistCta.propTypes = {
  language: PropTypes.string.isRequired,
  advertisingView: PropTypes.bool,
  sendDemoEvent: PropTypes.func,
};

export default SpecialistCta;
